import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Animations
import { slideInDownAnimation } from '../../../app/app.animation';
// Common
import { AngularMaterialService, ErrorParseService, IExpType, LGEDataService } from '../../../commons';
// State
import { Store } from '@ngrx/store';
import * as fromExpType from './state/exp-type.selectors';
import * as ExpTypeAction from './state/exp-type.actions';
import * as lgeApp from '../../../app/state/app.actions';
import { Observable, Subscription, skipWhile } from 'rxjs';
// import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

@Component({
    selector: 'exp-type-screen',
    templateUrl: 'exp-type.component.html',
    styleUrls: ['exp-type.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpTypeExtScreenComponent implements OnInit, OnDestroy {
    @Input() pending$: Observable<boolean>;
    pendingSubscription: Subscription;
    pending: boolean;
    @Input() error$: Observable<string | null>;
    errorSubscription: Subscription;
    error: string | null;
    @Input() stateData$: Observable<IExpType | null>;
    stateDataSubscription: Subscription;
    stateData: IExpType | null;

    getData: string = 'EXP_TYPE';

    expTypeCCDetails = [];
    expTypeCIDetails = [];
    expTypePPDetails = [];
    isNullExpTypeDetails: boolean = false;
    isLoadingExpTypeDetails: boolean = false;
    showErrorExpTypeDetails: boolean = false;
    errorMessageExpTypeDetails: string;

    // @ViewChild(MatPaginator) paginator: MatPaginator;
    // @ViewChild(MatSort) sort: MatSort;

    // displayedColumns = ['code', 'description'];
    // dataSource: MatTableDataSource<any>;


    constructor(
        private store: Store<fromExpType.State>,
        private ref: ChangeDetectorRef,
        private fb: FormBuilder,
        private ams: AngularMaterialService,
        private errorParse: ErrorParseService,
        private _dataService: LGEDataService
    ) {
        this.selectState();
        this.createForms();
        // this.dataSource = new MatTableDataSource([]);
    }


    ngOnInit() {
        this.startSubscriptions();
        this.getActiveExpTypeDataCC();
        // this.getActiveExpTypeDataCI();
        // this.getActiveExpTypeDataPFTP();
    }
    onTabChange(val) {
        if (val === 1 && this.expTypeCIDetails.length === 0) {
            this.ams.showLoader('Loading...');
            this.getActiveExpTypeDataCI();
        } else if (val === 2 && this.expTypePPDetails.length === 0) {
            this.ams.showLoader('Loading...');
            this.getActiveExpTypeDataPFTP();
        }
        // (selectChange)='onSelectChange($event)'  // HTML <mat-tab-group>
        // // console.log(event)
    }
    getActiveExpTypeDataCC() {
        this.isLoadingExpTypeDetails = true;
        this._dataService.AccDistInfo_GetActiveByName([this.getData, 'CC'])
            .subscribe({
                next: data => {
                    if (data) {
                        this.expTypeCCDetails = data;
                        this.isLoadingExpTypeDetails = false;
                        // console.log('selected exp-type list');
                        // console.log(data);
                        // this.dataSource = new MatTableDataSource(data);
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isNullExpTypeDetails = true;
                        this.errorMessageExpTypeDetails = 'There is not any selected exp-type';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingExpTypeDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorExpTypeDetails = true;
                    this.errorMessageExpTypeDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }

    getActiveExpTypeDataCI() {
        this.isLoadingExpTypeDetails = true;
        this._dataService.AccDistInfo_GetActiveByName([this.getData, 'CI'])
            .subscribe({
                next: data => {
                    if (data) {
                        this.expTypeCIDetails = data;
                        this.isLoadingExpTypeDetails = false;
                        // console.log('selected exp-type list');
                        // console.log(data);
                        // this.dataSource = new MatTableDataSource(data);
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isNullExpTypeDetails = true;
                        this.errorMessageExpTypeDetails = 'There is not any selected exp-type';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingExpTypeDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorExpTypeDetails = true;
                    this.errorMessageExpTypeDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }

    getActiveExpTypeDataPFTP() {
        this.isLoadingExpTypeDetails = true;
        this._dataService.AccDistInfo_GetActiveByName([this.getData, 'PP'])
            .subscribe({
                next: data => {
                    if (data) {
                        this.expTypePPDetails = data;
                        this.isLoadingExpTypeDetails = false;
                        // console.log('selected exp-type list');
                        // console.log(data);
                        // this.dataSource = new MatTableDataSource(data);
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isNullExpTypeDetails = true;
                        this.errorMessageExpTypeDetails = 'There is not any selected exp-type';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingExpTypeDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorExpTypeDetails = true;
                    this.errorMessageExpTypeDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }

    editExpTypeListCC() {
        this.ams.showLoader('Loading...');
        this._dataService.AccDistInfo_GetByName([this.getData, 'CC'])
            .subscribe({
                next: data => {
                    // console.log('exp-type list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showAccDistDetails('Exp-Type (CC)', '', data);
                    this.ams.accDist.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected exp-type CC');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.AccDistInfo_Update([result, 'CC'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveExpTypeDataCC();
                                            this.ref.markForCheck();
                                        }
                                    },
                                    error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                    }
                                }
                                );
                        }
                    });
                },
                error: error => {
                    // console.log(error);
                }
            });
    }

    editExpTypeListCI() {
        this.ams.showLoader('Loading...');
        this._dataService.AccDistInfo_GetByName([this.getData, 'CI'])
            .subscribe({
                next: data => {
                    // console.log('exp-type list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showAccDistDetails('Exp-Type (CI)', '', data);
                    this.ams.accDist.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected exp-type CI');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.AccDistInfo_Update([result, 'CI'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveExpTypeDataCI();
                                            this.ref.markForCheck();
                                        }
                                    },
                                    error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                    }
                                }
                                );
                        }
                    });
                },
                error: error => {
                    // console.log(error);
                }
            });
    }

    editExpTypeListPFTP() {
        this.ams.showLoader('Loading...');
        this._dataService.AccDistInfo_GetByName([this.getData, 'PP'])
            .subscribe({
                next: data => {
                    // console.log('exp-type list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showAccDistDetails('Exp-Type (PFTP)', '', data);
                    this.ams.accDist.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected exp-type PFTP');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.AccDistInfo_Update([result, 'PP'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveExpTypeDataPFTP();
                                            this.ref.markForCheck();
                                        }
                                    },
                                    error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                    }
                                }
                                );
                        }
                    });
                },
                error: error => {
                    // console.log(error);
                }
            });
    }

    // Select state
    selectState(): void {
        this.pending$ = this.store.select(fromExpType.getExpTypeScreenPending);
        this.stateData$ = this.store.select(fromExpType.getExpTypeState);
        this.error$ = this.store.select(fromExpType.getExpTypeScreenError).pipe(skipWhile(error => error === undefined || error === null || error === ''));
    }

    displayLoader(pending: boolean): void {
        if (pending) {
            setTimeout(() => {
                this.ams.showLoader('Loading...');
                this.ref.markForCheck();
            })
        } else {
            this.ams.closeDialog().then(() => {
                if (this.error !== null && this.error !== undefined && this.error !== '') {
                    this.displayError(this.error);
                }
            });
        }
    }

    displayError(error: any): void {
        let errorMessage;
        if (this.errorParse.foundKeyWord(error, "CORPCOMMONWS")) {
            errorMessage = this.errorParse.translateCCError(error);
        } else {
            errorMessage = error instanceof Object ? error.message : error;
        }
        this.ams.showAlert("Loading Error", errorMessage);
        this.ams.alert.afterClosed().subscribe(result => {
            this.store.dispatch(new ExpTypeAction.ExpTypeScreenErrorReset());
        });
    }

    // Create reactive forms
    createForms(): void {

    }
    // Opens sidenav if on mobile
    public openSidenav(): void {
        this.store.dispatch(new lgeApp.OpenSidenav());
    }
    // Subscribe to state data and mark it for changes
    startSubscriptions(): void {
        this.pendingSubscription = this.pending$
            .subscribe(data => {
                this.pending = data;
                this.displayLoader(this.pending);
                this.ref.markForCheck();
            });
        this.errorSubscription = this.error$
            .subscribe(data => {
                this.error = data;
                this.ref.markForCheck();
            });
        this.stateDataSubscription = this.stateData$
            .subscribe(data => {
                this.stateData = data;
                this.ref.markForCheck();
            });
    }
    // Unsubscribe from state data changes
    endSubscriptions(): void {
        this.pendingSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();
        this.stateDataSubscription.unsubscribe();
    }

    ngOnDestroy() {
        this.endSubscriptions();
    }


}